import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_inventory_summary_by_location,
    getReportLabel: () => t`Inventory Summary by Location`,
    getColumns: () => [],
};
